import { useDispatch, useSelector } from 'react-redux'
import { CardButton } from 'shared/ui/CardButton'
import cls from './Choosebar.module.scss'
import {
    acceptMoment,
    getActivityPending,
    getArrayCard,
    getIsLoaded,
    rejectMoment,
    wantMoment,
} from 'features/anonymousAuth'
import { specialActions } from 'features/specialData/model/slice/specialSlice'
import { memo } from 'react'
import { classNames } from 'shared/lib/classNames/classNames'
import { getSpecialArrayCard } from 'features/specialData'

export const Choosebar = memo((props) => {
    const { clearInterval, activeButton, clearOnBoard, onSpeak, mode } = props
    const dispatch = useDispatch()
    const isLoaded = useSelector(getIsLoaded)
    const activityPending = useSelector(getActivityPending)
    let cardData = useSelector(
        mode === 'special' ? getSpecialArrayCard : getArrayCard
    ) // если special то другой редюсер
    cardData = cardData.slice().reverse()
    const showedCardData = [...cardData.splice(0, 1)]

    const finishChoice = async (regularAction, specialAction) => {
        if (mode === 'special') {
            dispatch(specialAction)
        } else {
            const outcome = await dispatch(regularAction)
            if (!outcome.applied) return
        }
        clearInterval()
        clearOnBoard()
    }

    const onAccept = () => {
        onSpeak(showedCardData[0].speak)
        finishChoice(
            acceptMoment([showedCardData[0], [1000, 0]]),
            specialActions.wantMoment([showedCardData[0], [1000, 0]])
        )
    }

    const onReject = () => {
        onSpeak(showedCardData[0].speak)

        finishChoice(
            rejectMoment([showedCardData[0], [-1000, 0]]),
            specialActions.rejectMoment([showedCardData[0], [-1000, 0]])
        )
    }

    const onWant = () => {
        onSpeak(showedCardData[0].speak)

        finishChoice(
            wantMoment([showedCardData[0], [0, -2000]]),
            specialActions.wantMoment([showedCardData[0], [0, -2000]])
        )
    }

    const modeChoose = {
        [cls.Disabled]: !isLoaded || activityPending,
    }

    return (
        <div className={classNames(cls.Choosebar, modeChoose, [])}>
            <CardButton
                disabled={!isLoaded || activityPending}
                activeButton={activeButton}
                action={onReject}
                type="reject"
            />
            <CardButton
                disabled={!isLoaded || activityPending}
                activeButton={activeButton}
                action={onWant}
                type="want"
            />
            <CardButton
                disabled={!isLoaded || activityPending}
                activeButton={activeButton}
                action={onAccept}
                type="accept"
            />
        </div>
    )
})
